import axios from 'axios';

const api = axios.create({
    baseURL: 'https://billtronapi.patronservices.in/',
   // baseURL: 'http://192.168.29.214:8080/',
    timeout: 80000,
    headers: {
        'Content-Type': 'application/json',
    }
});

// Request interceptor to add auth token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('userToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for handling errors
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response?.status === 401) {
            // Handle unauthorized - redirect to login
            localStorage.removeItem('userToken');
            localStorage.removeItem('userData');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export const handleCatch = (error) => {
    if (error.response) {
        // Request made and server responded
        const message = error.response.data.title || error.response.data.message || 'An error occurred';
        console.error('API Error:', message);
        return message;
    } else if (error.request) {
        console.error('Network Error');
        return 'Network Error';
    } else {
        console.error('Error:', error.message);
        return error.message;
    }
};

export default api;
